var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1289 40.9096H31.6937V45.4312H18.1289V40.9096ZM18.1289 49.9528H40.7368V54.4744H18.1289V49.9528Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2371 13.7801V13.2801H40.7371H31.6939H31.1939V13.7801V22.8232V23.3232H31.6939H40.7371H41.2371V22.8232V13.7801ZM13.1075 58.996V59.496H13.6075H58.8257H59.3257L59.3257 58.9959L59.3234 13.78L59.3234 13.2801H58.8234H45.2586H44.7586V13.7801V26.8448H27.6723V13.7801V13.2801H27.1723H13.6075H13.1075V13.7801V58.996ZM10.7652 10.9377C11.5192 10.1837 12.5415 9.75961 13.6078 9.75848H58.8231C59.8895 9.75961 60.9118 10.1837 61.6658 10.9377C62.4198 11.6918 62.8439 12.7142 62.845 13.7806V58.9955C62.8439 60.0619 62.4198 61.0843 61.6658 61.8383C60.9117 62.5924 59.8893 63.0165 58.8229 63.0175H13.608C12.5416 63.0165 11.5192 62.5924 10.7652 61.8383C10.0112 61.0843 9.58706 60.062 9.58594 58.9957V13.7803C9.58706 12.714 10.0112 11.6917 10.7652 10.9377Z",
    fill: "white",
    stroke: "#858487"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.132500e638ec7e7e02d5f7c8d6c6440a.svg";
export { ForwardRef as ReactComponent };